var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShippingCreate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59998 13.2V3.31595C6.59998 3.00355 6.85353 2.75 7.16593 2.75H13.1835C13.4964 2.75 13.75 3.00355 13.75 3.31595V13.2",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65002 16.5V10.5001C1.65002 10.1376 1.87057 9.81201 2.20717 9.67726L6.60003 7.97501",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65002 17.6V18.7",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.05 11.55V2.01466C17.05 1.50976 17.4597 1.10001 17.9646 1.10001C18.0867 1.10001 18.2077 1.12421 18.3205 1.17206L24.2214 3.66136C24.5382 3.77466 24.75 4.07441 24.75 4.41101V10.45",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 4.40002V7.15003",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.40002V7.15003",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1 14.85V10.901C23.1 10.6519 23.3018 10.45 23.551 10.45H26.9698C27.2624 10.45 27.5 10.2124 27.5 9.91926V7.11921C27.5 6.83266 27.7326 6.60001 28.0192 6.60001H31.3808C31.6673 6.60001 31.9 6.83266 31.9 7.11921V23.65",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2 31.9C27.2376 31.9 29.7 29.4376 29.7 26.4C29.7 23.3624 27.2376 20.9 24.2 20.9C21.1624 20.9 18.7 23.3624 18.7 26.4C18.7 29.4376 21.1624 31.9 24.2 31.9Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04999 31.9C9.08755 31.9 11.55 29.4376 11.55 26.4C11.55 23.3624 9.08755 20.9 6.04999 20.9C3.01242 20.9 0.549988 23.3624 0.549988 26.4C0.549988 29.4376 3.01242 31.9 6.04999 31.9Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 16.3697C13.75 16.7453 13.4459 17.05 13.0702 17.05H8.25057C7.64282 17.05 7.15057 16.5578 7.15057 15.95C7.15057 15.3423 7.64282 14.85 8.25057 14.85H11.1177C11.4026 14.85 11.6831 14.916 11.9378 15.0436L13.3744 15.7619C13.6043 15.8769 13.75 16.1123 13.75 16.3697Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90051 17.05L14.3 25.85",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9043 19.25H11L6.34595 26.2449",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05 29.7C4.2273 29.7 2.75 28.2227 2.75 26.4",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.95 14.85V14.2164C15.95 13.6548 16.4049 13.2 16.9664 13.2H19.332C19.6119 13.2 19.8611 13.3771 19.9535 13.6416L24.37 26.3378",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.523 25.85H14.3L20.9 19.25",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 26.4C27.5 28.2227 26.0227 29.7 24.2 29.7",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.9H30.8",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9 31.9H33",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingCreate);
export default __webpack_public_path__ + "static/media/shippingCreate.d694bf10.svg";
export { ForwardRef as ReactComponent };